module.exports = __webpack_public_path__ + "img/lluvia.d793fed2.svg";